import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const Modal = (props) => {
  const {
    children = [],
    close,
    contentClass = null,
    footerContent = [],
    headerContent = [],
    id,
    prompt = false,
    showHeader = false,
    showFooter = false,
    status,
  } = props;

  const overlayClass = ['modal-outer'];
  if (status === 'hidden') { overlayClass.push('hidden'); }
  if (prompt) { overlayClass.push('prompt'); }

  const containerClass = ['modal-container'];
  const modalClass = ['modal-content'];

  if (!showHeader) { modalClass.push('no-header'); }
  if (!showFooter) { modalClass.push('no-footer'); }
  if (contentClass) {
    containerClass.push(contentClass);
    modalClass.push(contentClass);
  }

  function stopPropagation(e) {
    e.stopPropagation();
  }

  function header() {
    return showHeader
      ? (
        <div id={`${id}-header`} className="modal-header">
          {headerContent}
        </div>
      )
      : null;
  }

  function footer() {
    return showFooter
      ? (
        <div className="modal-footer">
          {footerContent}
        </div>
      )
      : null;
  }

  return (
    <div
      id={id}
      role="button"
      tabIndex={0}
      className={overlayClass.join(' ')}
      onMouseDown={close}
      onKeyPress={close}
    >
      <div
        role="button"
        tabIndex={0}
        className={containerClass.join(' ')}
        onMouseDown={stopPropagation}
        onKeyPress={stopPropagation}
      >
        { header() }
        <div className={modalClass.join(' ')}>
          {
            status === 'loading'
              ? <div className="modal-loading" />
              : children
          }
        </div>
        { footer() }
      </div>
    </div>
  );
};

Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.object,
    PropTypes.node,
  ]),
  close: PropTypes.func.isRequired,
  contentClass: PropTypes.string,
  footerContent: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  headerContent: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  id: PropTypes.string.isRequired,
  prompt: PropTypes.bool,
  showHeader: PropTypes.bool,
  showFooter: PropTypes.bool,
  status: PropTypes.string.isRequired,
};

export default Modal;
